import { useRecoilValue } from 'recoil';
import { exchangeRateState } from '../store/exchangeRateAtom';
import { selectedCurrencyState } from '../store/selectedCurrencyAtom';

export const useConvertPrice = () => {
  const exchangeRates = useRecoilValue(exchangeRateState);
  const selectedCurrency = useRecoilValue(selectedCurrencyState);

  const convertPrice = (priceInEur, discount) => {
    let finalPrice = priceInEur;
    if (discount && discount > 0) {
      finalPrice = finalPrice * (1 - discount / 100);
    }

    if (selectedCurrency === 'EUR') return finalPrice.toFixed(2);

    const rate = exchangeRates.find(
      (rate) => rate.currency === selectedCurrency
    )?.rate;

    if (!rate) return finalPrice.toFixed(2); // Fallback to EUR if rate is not available
    return (finalPrice * rate).toFixed(2);
  };

  return convertPrice;
};